import i18n from '@/lib/i18n/i18n';

import type { RiskObjectGroups, ROTrailerMinimal } from '../types';

const GROUPS: RiskObjectGroups<ROTrailerMinimal> = [
  {
    title: 'RO_SECTION_OVERVIEW',
    properties: [
      {
        label: 'RO_TRAILER_NAME',
        getValue: (trailer) => trailer.name,
      },
      {
        label: 'RO_TRAILER_BRAND',
        getValue: (trailer) => trailer.brand,
      },
      {
        label: 'RO_TRAILER_TYPE',
        getValue: (trailer) => i18n.t(`TRAILER_TYPE_${trailer.vehicle_type}`),
      },
      // {
      //   label: 'RO_TRAILER_MODEL_YEAR',
      //   getValue: (trailer) => trailer.model_year,
      // },
      // {
      //   label: 'RO_TRAILER_CONSTRUCTION_YEAR',
      //   getValue: (trailer) => trailer.construction_year,
      // },
    ],
  },
  {
    title: 'RO_SECTION_REGISTRATION',
    properties: [
      {
        label: 'RO_TRAILER_NUMBER_PLATE',
        getValue: (trailer) => trailer.number_plate,
      },
      // {
      //   label: 'RO_TRAILER_CHASSIS',
      //   getValue: (trailer) => trailer.chassis_number,
      // },
      // {
      //   label: 'RO_TRAILER_PLATE_TYPE',
      //   getValue: (trailer) =>
      //     i18n.t(`LICENSE_PLATE_${trailer.license_plate_type}`),
      // },
      // {
      //   label: 'RO_TRAILER_FIRST_REG',
      //   getValue: (trailer) => toDateString(trailer.registration_first),
      // },
      // {
      //   label: 'RO_TRAILER_PURCHASE_DATE',
      //   getValue: (trailer) => toDateString(trailer.purchase_date),
      // },
      // {
      //   label: 'RO_TRAILER_COUNTRY',
      //   getValue: (trailer) => trailer.country_of_registration,
      // },
    ],
  },
  {
    title: 'RO_SECTION_WEIGHT',
    properties: [
      // {
      //   label: 'RO_TRAILER_TARE_WEIGHT',
      //   getValue: (trailer) => `${trailer.tare_weight}kg`,
      // },
      // {
      //   label: 'RO_TRAILER_MAX_WEIGHT',
      //   getValue: (trailer) => `${trailer.max_weight}kg`,
      // },
      // {
      //   label: 'RO_TRAILER_TRUST_WEIGHT',
      //   getValue: (trailer) => `${trailer.trust_weight}kg`,
      // },
      // {
      //   label: 'RO_TRAILER_IS_TIPPER',
      //   getValue: (trailer) => trailer.is_tipper,
      // },
    ],
  },
];

export default GROUPS;
